import { useState } from 'react';
import axios from 'axios';
import { API_VERSION } from '../data/constants';

const HOST =
	process.env.NODE_ENV === 'development'
		? process.env.REACT_APP_DEV_SERVER_URL
		: process.env.REACT_APP_PROD_SERVER_URL;

const initialState = {
	projects: [],
	testimonials: [],
	messages: [],
};

export default function useAdminData() {
	const [data, setData] = useState(initialState);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const getData = () => {
		return data;
	};

	const getProjects = async () => {
		return axios
			.get(`${HOST}/api/${API_VERSION}/projects?limit=200`)
			.then(res => {
				setData(prev => ({
					...prev,
					projects: res.data.data.document,
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const getProject = async id => {
		return axios
			.get(`${HOST}/api/${API_VERSION}/projects/${id}`)
			.then(res => {
				setIsLoading(false);
				return res.data;
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const createProject = async projectData => {
		return axios
			.post(`${HOST}/api/${API_VERSION}/projects`, projectData)
			.then(res => {
				setData({
					...data,
					projects: [...data.projects, res.data.data.document],
				});
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const deleteProject = async id => {
		return axios
			.delete(`${HOST}/api/${API_VERSION}/projects/${id}`)
			.then(res => {
				setData({
					...data,
					projects: data.projects.filter(proj => proj._id !== id),
				});
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const updateProject = async (id, payload, index) => {
		return axios
			.patch(`${HOST}/api/${API_VERSION}/projects/${id}`, payload)
			.then(res => {
				setData(prev => ({
					...prev,
					projects: [
						...prev.projects.slice(0, index),

						{ ...res.data.data.document },

						...prev.projects.slice(index + 1),
					],
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const getTestimonials = async () => {
		return axios
			.get(`${HOST}/api/${API_VERSION}/testimonials`)
			.then(res => {
				setData(prev => ({
					...prev,
					testimonials: res.data.data.document,
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const getTestimonial = async id => {
		return axios
			.get(`${HOST}/api/${API_VERSION}/testimonials/${id}`)
			.then(res => {
				setIsLoading(false);
				return res.data;
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const createTestimonial = async testimonialData => {
		return axios
			.post(`${HOST}/api/${API_VERSION}/testimonials`, testimonialData)
			.then(res => {
				setData({
					...data,
					testimonials: [
						...data.testimonials,
						...res.data.data.document,
					],
				});
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const deleteTestimonial = async id => {
		return axios
			.delete(`${HOST}/api/${API_VERSION}/testimonials/${id}`)
			.then(res => {
				setData({
					...data,
					testimonials: data.testimonials.filter(
						testimonial => testimonial._id !== id
					),
				});
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const updateTestimonial = async (id, payload, index) => {
		return axios
			.patch(`${HOST}/api/${API_VERSION}/testimonials/${id}`, payload)
			.then(res => {
				setData(prev => ({
					...prev,
					testimonials: [
						...prev.testimonials.slice(0, index),

						{ ...res.data.data.document },

						...prev.testimonials.slice(index + 1),
					],
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const getMessages = async () => {
		return axios
			.get(`${HOST}/api/${API_VERSION}/messages`)
			.then(res => {
				setData(prev => ({
					...prev,
					messages: res.data.data.document,
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const getMessage = async id => {
		return axios
			.get(`${HOST}/api/${API_VERSION}/messages/${id}`)
			.then(res => {
				setIsLoading(false);
				return res.data.data.document;
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const deleteMessage = async id => {
		return axios
			.delete(`${HOST}/api/${API_VERSION}/messages/${id}`)
			.then(res => {
				setData({
					...data,
					messages: data.messages.filter(
						message => message._id !== id
					),
				});
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const sendMessage = async payload => {
		return axios
			.post(`${HOST}/api/${API_VERSION}/messages`, payload)
			.then(res => {
				setData(prev => ({
					...prev,
					messages: [...prev.messages, res.data.data.document],
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	const readMessage = async (id, status, index) => {
		return axios
			.patch(`${HOST}/api/${API_VERSION}/messages/${id}`, { read: !status })
			.then(res => {
				setData(prev => ({
					...prev,
					messages: [
						...prev.messages.slice(0, index),
						{
							...prev.messages[index],
							read: res.data.data.document.read,
						},
						...prev.messages.slice(index + 1),
					],
				}));
				setIsLoading(false);
			})
			.catch(error => {
				setError(error.response.data.message);
				setIsLoading(false);
			});
	};

	return {
		error,
		isLoading,
		data,
		getData,
		getProjects,
		getProject,
		createProject,
		deleteProject,
		updateProject,
		getTestimonials,
		getTestimonial,
		createTestimonial,
		deleteTestimonial,
		updateTestimonial,
		getMessages,
		getMessage,
		sendMessage,
		readMessage,
		deleteMessage,
	};
}
